<template>
  <transition
    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    leave-class="opacity-100 translate-y-0 sm:scale-100"
    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <div v-if="show" class="relative pointer-events-auto text-left transform transition-all sm:my-8 h-[65em] overflow-auto">
      <div class="bg-white py-6 h-full">
        <span v-if="!removeCloseButton" class="p-1 inline-block rounded-lg border border-gray-200 hover:bg-gray-50 group absolute top-0 right-0 mt-2 mr-2 cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-600 group-hover:text-gray-700 duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" @click="show = false">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </span>

        <div class="space-y-8">
          <div class="m-auto flex flex-col justify-center items-center space-y-2" :class="innerMaxWidth">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-20 w-20 text-gray-400">
              <path fill-rule="evenodd" d="M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 011.5 10.875v-3.75zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 01-1.875-1.875v-8.25zM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 013 18.375v-2.25z" clip-rule="evenodd" />
            </svg>
            <h1 class="text-2xl font-bold text-gray-600">
              Select a template to import
            </h1>
            <h2 class="text-lg">
              {{ message }}
            </h2>
          </div>
          <div class="m-auto" :class="innerMaxWidth">
            <div class="space-x-2 mt-2">
                        <span
                          v-for="item in availablePackages"
                          :key="item.uid"

                          class="text-sm font-semibold p-1 px-2 border border-gray-200 bg-gray-100 rounded-lg"
                        >
                          {{ item.name }}
                        </span>
            </div>
          </div>
          <div class="space-y-2">
            <h3 class="m-auto text-gray-600 text-sm uppercase font-bold" :class="innerMaxWidth">
              DEFAULT TEMPLATES
            </h3>
            <template v-if="loadingDefault || allDefaultTemplates.length">
              <div class="overflow-hidden pl-1 h-[27.8125rem]">
                <ul
                  class="pl-44 flex flex-nowrap overflow-auto scroll-smooth min-h-[40.0625rem]"
                  :class="[hasCarousel && 'space-x-4', !loadingDefault && 'disable-ske']"

                  ref="carousel"
                >
                  <TemplatePreview
                    v-for="(template, index) in loadingDefault ? templatePlaceholder : allDefaultTemplates" :key="template.uid"

                    :class="[
                              !hasCarousel && 'px-4',
                              index === 0 && '!pl-0'
                            ]"
                    v-bind="template"
                    :defaultTemplate="true"
                    :show-package="true"
                    :selected="selectedTemplate === template.uid"
                    @click.native="selectedTemplate = template.uid"
                    :loading="loadingDefault"

                    @delete-template="deleteDefaultTemplate(template.uid)"
                    @edit-template="$emit('edit-template', {template, editorPackage: findTemplatePackage(template.uid)})"
                    @overwrite-config="overwriteDefaultConfig(template)"
                    @close-manager="closeManager"
                  />
                </ul>
              </div>
              <div v-if="hasCarousel" class="m-auto flex justify-between" :class="innerMaxWidth">
                        <span v-if="!hideBackButton" class="flex items-center space-x-2 font-semibold cursor-pointer items-center p-2 rounded-lg duration-200 hover:bg-gray-50 border border-gray-200" @click="back">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                          </svg>
                          <span class="-mt-1 cursor-pointer">
                            Go back
                          </span>
                        </span>
                <span v-else></span>
                <span v-if="!hideNextButton" class="flex items-center space-x-2 font-semibold cursor-pointer items-center p-2 rounded-lg duration-200 hover:bg-gray-50 border border-gray-200" @click="next">
                          <span class="-mt-1 cursor-pointer">
                            Show more
                          </span>
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                          </svg>
                        </span>
              </div>
            </template>
            <div v-else class="m-auto min-h-[12.5rem] border border-dashed border-gray-300 rounded-xl flex justify-center items-center" :class="innerMaxWidth">
              <div class="text-center">
                <h3 class="mt-2 text-sm font-medium text-gray-900">No default templates</h3>
                <p class="mt-1 text-sm text-gray-500 max-w-md">
                  There are no default templates for the available packages. <span v-if="isAdmin">As an admin, you can create one by clicking on the button below.</span>
                </p>
                <div v-if="isAdmin" class="mt-6">
                  <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" @click="$emit('trigger-default-template')">
                    <!-- Heroicon name: solid/plus -->
                    <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                    </svg>
                    New Template
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="m-auto space-y-2" :class="innerMaxWidth">
            <h3 class="text-gray-600 text-sm uppercase font-bold">
              CUSTOM TEMPLATES
            </h3>
            <ul v-if="!isAdmin && (loadingCustom || customTemplates.length)"
                class="grid grid-cols-3 gap-4"
                :class="!loadingCustom && 'disable-ske'"
            >
              <TemplatePreview
                v-for="template in loadingCustom ? templatePlaceholder : customTemplates" :key="template.uid"

                v-bind="template"
                :defaultTemplate="false"
                :show-package="false"
                :selected="selectedTemplate === template.uid"
                @click.native="selectedTemplate = template.uid"
                :loading="loadingCustom"

                @delete-template="deleteCustomTemplate(template.uid)"
                @edit-template="$emit('edit-template', {template, editorPackage: findTemplatePackage(template.uid)})"
                @overwrite-config="overwriteCustomConfig(template)"
                @close-manager="closeManager"
              />
            </ul>
            <div v-else-if="isAdmin" class="m-auto min-h-[12.5rem] flex-col border border-dashed border-gray-300 rounded-xl flex justify-center items-center" :class="innerMaxWidth">
              <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
              </svg>
              <span class="mt-2 block text-sm font-medium text-gray-900"> Admins cannot have custom templates </span>
            </div>
            <div v-else-if="!isAdmin && !loadingCustom && !customTemplates.length" :class="innerMaxWidth" class="m-auto min-h-[12.5rem] border border-dashed border-gray-300 rounded-xl flex justify-center items-center">
              <div class="text-center">
                <h3 class="mt-2 text-sm font-medium text-gray-900">No custom templates</h3>
                <p class="mt-1 text-sm text-gray-500 max-w-md">
                  There are no custom templates. You can add a new one by clicking on the button below.
                </p>
                <div class="mt-6">
                  <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" @click="$emit('trigger-default-template')">
                    <!-- Heroicon name: solid/plus -->
                    <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                    </svg>
                    New Custom Template
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showInnerShadow" class="shadow-inner absolute z-10 bg-transparent rounded-lg pointer-events-none left-0 top-0 w-full h-full"></div>
    </div>
  </transition>
</template>

<script>

import TemplatePreview from "./TemplatePreview.vue"

import { mapGetters } from "vuex"

export default {
  components: {
    TemplatePreview,
  },
  props: {
    value: [String, Boolean],
    removeCloseButton: Boolean,
    showInnerShadow: Boolean,
    message: String,
    innerMaxWidth: String,
  },
  data() {
    return {
      defaultTemplates: {},
      templatePlaceholder: [
        {
          name: "Main Template",
          package_name: "Hadiethshop",
          description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
          magento_config: "",
        },
        {
          name: "Responsive Magento Theme",
          package_name: "Porto",
          description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
          magento_config: "",
        },
        {
          name: "Responsive Magento Theme",
          package_name: "Porto",
          description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
          magento_config: "",
        },
        {
          name: "Responsive Magento Theme",
          package_name: "Porto",
          description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
          magento_config: "",
        },
      ],
      customTemplates: [],
      loadingDefault: false,
      loadingCustom: false,

      show: this.value || false,
      hideBackButton: false,
      hideNextButton: false,

      selectedTemplate: false,
    }
  },
  created() {
    this.reload()
  },
  mounted() {
    this.show && this.calculateCarouselData()
  },
  methods: {
    closeManager() {
      this.$emit('close-manager')
      this.selectedTemplate = null
    },
    async reload() {
      this.selectedTemplate = null
      this.readyToLoadPackages && this.loadPackageTemplates()
      !this.isAdmin && this.loadCustomTemplates()
    },
    async overwriteCustomConfig(template, magento_config) {
      this.$store.dispatch("toast/warning", {
        message: `Are you sure you want to overwrite this template?`,
        description: `It'll take the site's current config and overwrite the selected template's config. Please be sure to save your changes before continuing.`,
        confirm: {
          confirmMessage: "Overwrite config",
          cancelMessage: "No",
          onConfirm: async () => {
            try {
              await this.axios.put(`/api/custom-templates/${template.uid}`, { ...template, magento_config: this.stringifiedConfig })
              await this.$store.dispatch("toast/success", { message: "Successfully overwritten template!" })
            } catch (err) {
              await this.$store.dispatch("toast/handleError", err)
            }
            this.loadCustomTemplates()
          },
        },
      })
    },
    async overwriteDefaultConfig(template) {
      const packageId = this.findTemplatePackage(template.uid).uid
      packageId && this.$store.dispatch("toast/warning", {
        message: `Are you sure you want to overwrite this default template?`,
        description: `It'll take the site's current config and overwrite the selected template's config. This action will affect all of your customers. Please be sure to save your changes before continuing.`,
        confirm: {
          confirmMessage: "Overwrite config",
          cancelMessage: "No",
          onConfirm: async () => {
            try {
              await this.axios.put(`/api/editor-packages/${packageId}/templates/${template.uid}`, { ...template, magento_config: this.stringifiedConfig })
              await this.$store.dispatch("toast/success", { message: "Successfully overwritten template!" })
            } catch (err) {
              await this.$store.dispatch("toast/handleError", err)
            }
            this.loadCustomTemplates()
          },
        },
      })
    },
    async loadCustomTemplates() {
      this.loadingCustom = true
      this.customTemplates = (await this.axios.get(`/api/custom-templates`)).data.results
      this.loadingCustom = false
    },
    async deleteCustomTemplate(templateId) {
      this.$store.dispatch("toast/warning", {
        message: `Are you sure you want to delete this template?`,
        description: `This action can't be undone, and your template will be lost forever.`,
        confirm: {
          confirmMessage: "Delete",
          cancelMessage: "No",
          onConfirm: async () => {
            this.loadingCustom = true

            try {
              await this.axios.delete(`/api/custom-templates/${templateId}`)
              await this.$store.dispatch("toast/success", { message: "Successfully deleted template!" })
            } catch (err) {
              await this.$store.dispatch("toast/handleError", err)
            }
            await this.loadCustomTemplates()

            this.loadingCustom = false
          },
        },
      })
    },
    async loadPackageTemplates() {
      this.loadingDefault = true

      await Promise.all(
        this.availablePackages.map(async pack => {
          this.defaultTemplates[pack.uid] = (await this.axios.get(`/api/editor-packages/${pack.uid}/templates`)).data.results
        })
      )

      this.loadingDefault = false
      this.defaultTemplates = { ...this.defaultTemplates }
    },
    findTemplatePackage(templateId) {
      const packageId = Object.keys(this.defaultTemplates).find(candidatePackage => {
        return this.defaultTemplates[candidatePackage].some(template => template.uid === templateId)
      })
      return this.availablePackages.find(pack => pack.uid === packageId)
    },
    async deleteDefaultTemplate(templateId) {
      const packageId = this.findTemplatePackage(templateId).uid
      packageId && this.$store.dispatch("toast/warning", {
        message: `Are you sure you want to delete this template?`,
        description: `This action can't be undone, and your template will be lost forever. Your customers won't have access to this template anymore.`,
        confirm: {
          confirmMessage: "Delete",
          cancelMessage: "No",
          onConfirm: async () => {
            this.loadingDefault = true

            try {
              await this.axios.delete(`/api/editor-packages/${packageId}/templates/${templateId}`)
            } catch (err) {
              await this.$store.dispatch("toast/handleError", err)
            }
            await this.loadPackageTemplates()

            await this.$store.dispatch("toast/success", { message: "Successfully deleted template!" })
          },
        },
      })
    },

    calculateCarouselData() {
      const calc = () => {
        if (!this.$refs.carousel) return;
        this.hideBackButton = this.$refs.carousel.scrollLeft === 0
        this.hideNextButton = (this.$refs.carousel.scrollLeft + this.$refs.carousel.clientWidth + 1) > this.$refs.carousel.scrollWidth
      }
      calc()
      setTimeout(() => calc(), 300)
    },
    next() {
      if (!this.$refs.carousel) return;
      this.$refs.carousel.scrollLeft = this.$refs.carousel.scrollLeft + 303
      this.calculateCarouselData()
    },
    back() {
      if (!this.$refs.carousel) return;
      this.$refs.carousel.scrollLeft = this.$refs.carousel.scrollLeft - 303
      this.calculateCarouselData()
    },
  },
  computed: {
    ...mapGetters({
      availablePackages: 'editor/availablePackages',
      stringifiedConfig: 'editor/stringifiedConfig',
      isAdmin: 'isAdmin',
    }),

    allDefaultTemplates() {
      const templates = Object.values(this.defaultTemplates).flat()
      templates.sort((a, b) => a.name.localeCompare(b.name))

      return templates
    },
    hasCarousel() {
      return this.defaultTemplates.length > 3
    },
    readyToLoadPackages() {
      return this.show && this.availablePackages.length
    },
  },
  watch: {
    value(val) {
      this.show = val
      setTimeout(() => {
        this.calculateCarouselData()
      }, 300)
    },
    show(show) {
      this.$emit("input", show)
    },
    readyToLoadPackages() {
      this.loadPackageTemplates()
    },
  },
}

</script>
